<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="editedItem.permissions"
      :items-per-page="50"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Permisos de Usuario</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn class="mx-2 my-2" small fab dark color="primary" v-on="on" @click.stop="$refs.selectUser.show()">
                <v-icon dark>fa-plus</v-icon>
              </v-btn>
            </template>
            <span>Nuevo</span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon @click="deleteItem(item)" v-on="on" class="mr-1 my-1" color="error">fa-trash</v-icon>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <SelectUser ref="selectUser" @setUser="setUser"/>
  </div>
</template>

<script>
  import SelectUser from '../../config/User/SelectUser';
  export default {
    name:'Permission',
    components: {SelectUser},
    props: {
      editedItem: {
        type: Object,
        default: null,
      },
    },
    data(){
      return {
        headers:[
          { text: 'Id', value: 'identity' },
          { text: 'Nombre', value: 'name' },
          { text: 'Acciones', value: 'action', sortable: false },
        ],
        defaultItem: {id: 0, file: null, is_public:false, signatures:[], permissions:[]},
      }
    },
    methods: {
      async setUser(user){
        var _this2 = this
        var valid = true
        await Promise.all(_this2.editedItem.permissions.map(s=> {
          if(user.id==s.id){
            valid = false
            this.$root.$alert({text:"Usuario ya existe",color:"error",timeout:2000})
          }
        }))
        
        if(valid){
          this.editedItem.permissions.push(user)
          this.$root.$alert({text:"Añadido con éxito",color:"success",timeout:2000})
        }
        this.$refs.selectUser.show()
      },
      deleteItem (item) {
        this.$root.$confirm('Eliminar Permiso', 'Esta Seguro?', { color: 'red' })
        .then(async (res) => {
          if(res){
            try{
              this.editedItem.permissions = this.editedItem.permissions.filter(s=>s.id!=item.id)
            }catch(error){
              console.error(error)
              this.$root.$alert({text:"Imposible Eliminar Registro",color:"error",timeout:3000})
            }
          }else{
            this.$root.$alert({text:"Acción Cancelada",color:"warning",timeout:1000})
          }
        })
      },
    }

  }
</script>

<style>

</style>